import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { defaultLayout, authLayout } from "./layouts";

// Route Views
import HomeView from "./components/home/home";
import OrderEntryView from "./components/orderentry/OrderEntry";
import ArtworkProofingView from "./components/artworkproofing/ArtworkProofing";
import ProductionView from "./components/production/Production";
import ShippingView from "./components/shipping/Shipping";
import InvoicingView from "./components/invoicing/Invoicing";

export default [
  {
    path: "/",
    exact: true,
    layout: authLayout,
    component: () => <Redirect to="/home" />
  },
  {
    path: "/home",
    layout: authLayout,
    component: HomeView
  },
  {
    path: "/orderentry",
    layout: defaultLayout,
    component: OrderEntryView
  },
  {
    path: "/artworkproofing",
    layout: defaultLayout,
    component: ArtworkProofingView
  },
  {
    path: "/production",
    layout: defaultLayout,
    component: ProductionView
  },
  {
    path: "/shipping",
    layout: defaultLayout,
    component: ShippingView
  },
  {
    path: "/invoicing",
    layout: defaultLayout,
    component: InvoicingView
  }
];